module.exports = __webpack_public_path__ + "static/media/icons-sprites.a97fe394.svg";